
<div class="wrapper">
  <div class="content-wrapper">
    <div class="br-section-wrapper">
      <!-- <div class="header_frm">
        <h2>Dashboard</h2>
      </div> -->
      <div>

        <div class="form-group hidden">
          <div class="input-group">
            <input name="datepicker"
                   class="form-control"
                   style="display: none;"
                   ngbDatepicker
                   #datepicker="ngbDatepicker"
                   [autoClose]="'outside'"
                   (dateSelect)="onDateSelection($event)"
                   [displayMonths]="2"
                   [dayTemplate]="t"
                   outsideDays="hidden"
                   [startDate]="fromDate">
            <ng-template #t let-date let-focused="focused">
              <span class="custom-day"
                    [class.focused]="focused"
                    [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)"
                    (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                {{ date.day }}
              </span>
            </ng-template>
          </div>
        </div>
        
        <div class="row" style="margin-top: 10px;">
          <div class="form-group col-sm-4">
            <div class="input-group">
              <label>From: </label>
              <input #dpFromDate
                    class="form-control height-35" placeholder="yyyy-mm-dd"
                    name="dpFromDate"
                    [value]="formatter.format(fromDate)"
                    (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar height-35" (click)="datepicker.toggle()" type="button">
                  <i class="fa fa-calendar" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="form-group ml-2 col-sm-4">
            <div class="input-group">
              <label>To: </label>
              <input #dpToDate
                    class="form-control height-35" placeholder="yyyy-mm-dd"
                    name="dpToDate"
                    [value]="formatter.format(toDate)"
                    (input)="toDate = validateInput(toDate, dpToDate.value)">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar height-35" (click)="datepicker.toggle()" type="button">
                  <i class="fa fa-calendar" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="form-group" style="margin-left: 10px;">
            <button class="btn height-35" style="background-color: #44cbc0;color: #fff;" (click)="getHeapStatus()">Get Status</button>
          </div>
        </div>
        <div style="display: block;" *ngIf="apiResponse">
          <canvas baseChart
            [datasets]="lineChartData"
            [labels]="lineChartLabels"
            [options]="lineChartOptions"
            [colors]="lineChartColors"
            [legend]="lineChartLegend"
            [chartType]="lineChartType"
            [plugins]="lineChartPlugins">
          </canvas>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>

</div>
